import { Module } from 'vuex';
import { RootState } from 'frontend/types';

interface ViewedReferralModalState {
  userHasSeenReferralModal: boolean;
}

const viewedReferralModal: Module<ViewedReferralModalState, RootState> = {
  namespaced: true,
  state: {
    userHasSeenReferralModal: false,
  },
  mutations: {
    setValue(state: ViewedReferralModalState, data: { value: boolean }): void {
      state.userHasSeenReferralModal = data.value;
    },
  },
  actions: {},
};

export default viewedReferralModal;
